import { View, Text, ScrollView, StyleSheet } from "react-native";
import React from "react";
import Product from "./Product";
import ProductList from "./ProductList";
import { useStateContext } from "../lib/context";

const EnuCollection = (props) => {
  const page = props.pagination * 24;
  const pagination = props.products.slice(page - 24, page);

  const { productImages } = useStateContext();
  const ImageFinder = (sku) => productImages.get(sku) || "";

  return (
    <ScrollView>
       <View
        style={props.type ? localStyles.listContainer : localStyles.gridContainer}
      >
        {pagination.map((item) => {
          if (props.type) {
            return (
              <ProductList
                key={item.ARTICULO__ID}
                name={item.DENOMINACION}
                price={item.PRECIOVENTA}
                stock={item.STOCK}
                sku={item.ARTICULO__ID}
                type={item.TIPO__ID}
                Image={ImageFinder(item.ARTICULO__ID)}
              />
            );
          } else {
            return (
              <Product
                key={item.ARTICULO__ID}
                name={item.DENOMINACION}
                price={item.PRECIOVENTA}
                stock={item.STOCK}
                sku={item.ARTICULO__ID}
                type={item.TIPO__ID}
                Image={ImageFinder(item.ARTICULO__ID)}
              />
            );
          }
        })}
      </View>
    </ScrollView>
  );
};

export default EnuCollection;

const localStyles = StyleSheet.create({
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: 10,
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    gap: 10,
  },
});
